import Plans from './PlansContainer';

export default Plans;
